td
<template>
  <div class="bigBox">
    <div class="page-box" style="padding-top: 0">
      <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
      <input id="completeNum" v-model="completeNum" v-show="false" />
      <span>{{ completeNum }}</span>
      <!-- 顶部 -->
      <div class="hearder">
        <div class="image">
          <div class="title">
            <p>职业教育“{{ header.zykName }}”专业教学资源库</p>
            <p>{{ header.nowTime }}年度运行报告</p>
            <span>资源库编号：{{ header.zykNum }}</span>
            <span>分析时间：{{ header.startTime }}至{{ header.endTime }}</span>
          </div>
        </div>
      </div>
      <!-- 第一个标题 -->
      <div class="Title">
        <div class="fristTitle">
          <div class="line"></div>
          <h1>资源库全国数据</h1>
          <div class="line"></div>
        </div>
        <div class="content">
          <p>
            截止到{{ header.nowTime }}年，国家级职业教育专业教学资源库已立项<span class="yellow"
              >203</span
            >个
          </p>
          <p>
            已有<span class="yellow">{{ Handler1[0] }}</span
            >余所职业院校、<span class="yellow">{{ getUtils_Fun(Handler1[1]) }}</span
            >余所行业企业参与建设
          </p>
          <p>
            课程总量已达<span class="yellow">{{ getUtils_Fun(Handler1[2]) }}</span
            >门
          </p>
          <p>
            素材资源总量已达<span class="yellow">{{ getUtils_Fun(Handler1[3]) }}</span
            >余条
          </p>
        </div>
      </div>
      <!-- 第二个标题 -->
      <div class="Title">
        <div class="secondTitle">
          <div class="line"></div>
          <h1>资源库综合排名情况</h1>
          <div class="line"></div>
        </div>

        <div class="content">
          <p>根据资源库开展应用情况</p>
          <p>
            取<span class="yellow">全年访问量</span>、<span class="yellow"
              >无访问实名教师数和实名学生数</span
            >、<span class="yellow">无访问资源数</span>等多项指标进行综合排名
          </p>
          <p>
            本资源库在<span class="yellow">203</span>个国家级专业教学资源库中排名第<span
              class="yellow"
              >{{ top.zykRank }}</span
            >名
          </p>
          <p>请继续深入推广应用</p>
        </div>
      </div>
      <!-- 第三个标题 -->
      <div class="Title">
        <div class="fristTitle">
          <div class="line"></div>
          <h1>资源库基本数据分析</h1>
          <div class="line"></div>
        </div>
        <div class="chartBox" style="margin-bottom: 100px">
          <div class="left_box" style="width: 45%">
            <p>
              <span class="yellow">{{ year }}</span
              >年<span class="yellow">{{ month }}</span
              >月<span class="yellow">{{ day }}</span
              >日
            </p>
            <p>
              <span class="yellow">{{ Handler2.dataList[1] }}</span
              >老师上传了第一条资源
            </p>
            <p>
              资源名称：<span class="yellow">“{{ Handler2.dataList[2] || "" }}”</span>
            </p>
            <p>
              至今已经有<span class="yellow">{{ Handler2.dataList[3].replace(".0", "") || 0 }}</span
              >天
            </p>
            <p>
              资源库现有资源<span class="yellow">{{ typeDistribution.total }}</span
              >条
            </p>
          </div>
          <div class="right_box" style="width: 100%">
            <div class="chart_box">
              <div class="standards_content echartsHeight" style="width: 100%">
                <circularChart
                  :seriesRight="'38%'"
                  :isShowTextColor="true"
                  :refId="'typeDistributionChart'"
                  :datas="typeDistribution.dataList"
                  :colorName="4"
                  :innerText="'数量'"
                  :legendBackgroundColor="true"
                  :legendLeft="'50%'"
                  :circleSize="58"
                  :showValue="true"
                  :unit="'条'"
                ></circularChart>
              </div>
            </div>
            <p>素材资源占比</p>
          </div>
        </div>
      </div>
    </div>
    <div class="page-box">
      <!-- 第三个标题 -->
      <div class="Title">
        <div class="chartBox">
          <div class="left_box" style="width: 45%">
            <p>
              <span class="yellow">{{ Handler4.year }}</span
              >年<span class="yellow">{{ Handler4.month }}</span
              >月<span class="yellow">{{ Handler4.day }}</span
              >日
            </p>
            <p>
              <span class="yellow">{{ Handler4.dataList[1] }}</span
              >老师建设了第一门课程
            </p>
            <p>
              课程名称：<span class="yellow">《{{ Handler4.dataList[2] }}》</span>
            </p>
            <p>
              标准化课程<span class="yellow">{{ NowCourse.standardNum }}</span
              >门
            </p>
            <p>
              个性化课程<span class="yellow">{{ NowCourse.individuaNum }}</span
              >门
            </p>
          </div>
          <div class="right_box" style="width: 68%">
            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <circularChart
                  :seriesRight="'36.5%'"
                  :isShowTextColor="true"
                  :refId="'typeDistributionChart'"
                  :datas="NowCourse.dataList"
                  :colorName="4"
                  :innerText="'数量'"
                  :legendBackgroundColor="true"
                  :legendLeft="'60%'"
                  :circleSize="70"
                ></circularChart>
              </div>
            </div>
            <p>课程占比</p>
          </div>
        </div>
        <div class="chartBox" style="margin-bottom: 100px">
          <div class="left_box" style="width: 45%">
            <p>
              教师用户<span class="yellow">{{ getUtils_Fun(resourceLibrary.teacherNum) }}</span
              >人
            </p>
            <p>
              学生用户<span class="yellow">{{ getUtils_Fun(resourceLibrary.studentNum) }}</span
              >人
            </p>
            <p>
              企业用户<span class="yellow">{{ getUtils_Fun(resourceLibrary.enterpriseNum) }}</span
              >人
            </p>
            <p>
              社会学习者<span class="yellow">{{ getUtils_Fun(resourceLibrary.socialNum) }}</span
              >人
            </p>
          </div>
          <div class="right_box" style="width: 68%">
            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <circularChart
                  :seriesRight="'36.5%'"
                  :isShowTextColor="true"
                  :refId="'typeDistributionChart'"
                  :datas="resourceLibrary.dataList"
                  :colorName="4"
                  :innerText="'数量'"
                  :legendBackgroundColor="true"
                  :legendLeft="'60%'"
                  :circleSize="70"
                ></circularChart>
              </div>
            </div>
            <p>用户占比</p>
          </div>
        </div>
        <div class="chartBox Title m-top150">
          <div class="left_box" style="width: 45%">
            <p>
              资源库共被用户访问<span class="yellow">{{
                getUtils_Fun(allLogModuleCase.total)
              }}</span
              >次
            </p>
            <p>
              其中<span class="yellow">{{ allLogModuleCase.Max.name }}</span
              >用户最喜欢
            </p>
          </div>
          <div class="right_box" style="width: 68%">
            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <circularChart
                  :seriesRight="'36.5%'"
                  :isShowTextColor="true"
                  :refId="'typeDistributionChart'"
                  :datas="allLogModuleCase.dataList"
                  :colorName="4"
                  :innerText="'数量'"
                  :legendBackgroundColor="true"
                  :legendLeft="'60%'"
                  :circleSize="70"
                ></circularChart>
              </div>
            </div>
            <p>行为占比</p>
          </div>
        </div>
      </div>
    </div>
    <div class="page-box">
      <div class="Title">
        <div class="fristTitle" style="margin-top: 0">
          <div class="line"></div>
          <h1>资源库应用数据分析</h1>
          <div class="line"></div>
        </div>
        <div class="chartBoxTitle">
          <div class="left_box">
            <p>
              {{ header.nowTime }}年，新增资源<span class="yellow">{{ resourcesMonth.total }}</span
              >条
            </p>
            <p>
              资源共被访问<span class="yellow">{{ getUtils_Fun(accessMonth.total) }}</span
              >次
            </p>
            <p>访问量排名前十的资源如下：</p>
          </div>
        </div>
        <div class="chart_box">
          <div class="biaoge">
            <table
              border="1"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr>
                <th style="width: 7%">排名</th>
                <th style="width: 60%">资源名称</th>
                <th style="width: 24%">上传人</th>
                <th>访问量</th>
              </tr>

              <tr
                v-for="(item, index) in resourceVisits.tableList"
                :key="index"
                v-show="resourceVisits.tableList.length > 0"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.author }}</td>
                <td>{{ parseInt(item.num) }}</td>
              </tr>
              <tr v-show="resourceVisits.tableList.length == 0" class="nothing">
                <td colspan="4">无</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="chartBoxTitle m-top150">
          <div class="left_box">
            <p>
              {{ header.nowTime }}年，新增标准化课程<span class="yellow">{{
                Handler3.dataList[0]
              }}</span
              >门，新增个性化课程<span class="yellow">{{ Handler3.dataList[1] }}</span
              >门
            </p>
            <p>
              课程共被访问<span class="yellow">{{ getUtils_Fun(visitsMonth.total) }}</span
              >次
            </p>
            <p>访问量排名前十的课程如下：</p>
          </div>
        </div>
        <div
          class="chart_box"
          style="height: 576px"
          :class="{ height: this.$route.query.zykName == '印刷与数字印刷技术' }"
        >
          <div class="biaoge">
            <table
              border="1"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr>
                <th>排名</th>
                <th>课程名</th>
                <th>课程负责人</th>
                <th>访问量</th>
              </tr>

              <tr
                v-for="(item, index) in resourceVisits2.tableList"
                :key="index"
                v-show="resourceVisits2.tableList.length > 0"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.author }}</td>
                <td>{{ parseInt(item.num) }}</td>
              </tr>
              <tr v-show="resourceVisits2.tableList.length == 0" class="nothing">
                <td colspan="6">无</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="page-box">
      <div class="chartBox Title">
        <div
          class="left_box"
          style="width: 45%; display: flex; flex-direction: column; justify-content: center"
        >
          <p>{{ header.nowTime }}年</p>
          <p>
            新增教师用户<span class="yellow">{{ getUtils_Fun(usersMonth.teacherNum) }}</span
            >人
          </p>
          <p>
            新增学生用户<span class="yellow">{{ getUtils_Fun(usersMonth.studentNum) }}</span
            >人
          </p>
          <p>
            新增企业用户<span class="yellow">{{ getUtils_Fun(usersMonth.societyNum) }}</span
            >人
          </p>
          <p>
            新增社会学习者<span class="yellow">{{ getUtils_Fun(usersMonth.enterpriseNum) }}</span
            >人
          </p>
        </div>
        <div class="right_box" style="width: 68%">
          <div class="chart_box">
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'usersMonthChart'"
                :datas="usersMonth.dataList"
                :transverseData="usersMonth.transverseData"
                :colorList="usersMonth.colorList"
                :legendList="usersMonth.legendList"
                :innerText="'单位：人'"
                :isShowTextColor="true"
                :isExportTextColor="true"
              ></discountChart>
            </div>
          </div>
        </div>
      </div>
      <div class="chartBox Title m-top150">
        <div class="left_box" style="width: 50%">
          <p>{{ header.nowTime }}年</p>
          <p>
            资源库共被用户访问<span class="yellow">{{ getUtils_Fun(LogModuleCase.total) }}</span
            >次
          </p>
          <p>
            其中<span class="yellow">{{ LogModuleCase.Max.name }}</span
            >用户最喜欢
          </p>
        </div>
        <div class="right_box">
          <div class="chart_box">
            <div class="standards_content echartsHeight">
              <circularChart
                :seriesRight="'36.5%'"
                :isShowTextColor="true"
                :refId="'typeDistributionChart'"
                :datas="LogModuleCase.dataList"
                :colorName="4"
                :innerText="'数量'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="70"
              ></circularChart>
            </div>
          </div>
          <p>行为占比</p>
        </div>
      </div>
      <div class="chart_box m-top150">
        <div class="left_chart_box">
          <p>
            {{ header.nowTime }}年访问次数最多的老师是：<span class="yellow">{{
              tearcherList.Max
            }}</span>
          </p>
          <div class="standards_content echartsHeights">
            <tcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="tearcherList.dataList"
              :transverseData="tearcherList.transverseData"
              :colorList="tearcherList.colorList"
              :colorName="2"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
            ></tcolumnarChart>
          </div>
          <p>教师访问量排名</p>
        </div>
      </div>
    </div>
    <div class="page-box">
      <div class="chart_box">
        <div class="right_chart_box">
          <p>
            {{ header.nowTime }}年访问次数最多的学生是：<span class="yellow">{{
              studentList.Max
            }}</span>
          </p>
          <div class="standards_content echartsHeights">
            <tcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="studentList.dataList"
              :transverseData="studentList.transverseData"
              :colorList="studentList.colorList"
              :colorName="2"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
            ></tcolumnarChart>
          </div>
          <p>学生访问量排名</p>
        </div>
      </div>
      <div class="secondTitle m-top150">
        <div class="lines"></div>
        <h1>{{ header.nowTime - 1 }}年和{{ header.nowTime }}年建设与应用数据对比分析</h1>
        <div class="lines"></div>
      </div>
      <div class="chart_box">
        <div class="left_chart_box">
          <p>资源新增数量对比分析</p>
          <div class="standards_content echartsHeights">
            <vcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'participatingChart'"
              :datas="zykTotal.dataList"
              :transverseData="zykTotal.transverseData"
              :colorList="zykTotal.colorList"
              :legendList="zykTotal.legendList"
              :innerText="'单位：条'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></vcolumnarChart>
          </div>
        </div>
        <div class="right_chart_box m-top150">
          <p>课程新增数量对比分析</p>
          <div class="standards_content echartsHeights">
            <vcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'participatingChart'"
              :datas="courseTotal.dataList"
              :transverseData="courseTotal.transverseData"
              :colorList="courseTotal.colorList"
              :legendList="courseTotal.legendList"
              :innerText="'单位：门'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></vcolumnarChart>
          </div>
        </div>
      </div>
    </div>

    <div class="page-box" style="justify-content: space-between; padding-bottom: 0">
      <div class="chart_box">
        <div class="left_chart_box">
          <p>用户新增数量对比分析</p>
          <div class="standards_content echartsHeights">
            <vcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'participatingChart'"
              :datas="userTotal.dataList"
              :transverseData="userTotal.transverseData"
              :colorList="userTotal.colorList"
              :legendList="userTotal.legendList"
              :innerText="'单位：人'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></vcolumnarChart>
          </div>
        </div>
        <div class="right_chart_box m-top150">
          <p>访问量对比分析</p>
          <div class="standards_content echartsHeights">
            <discountChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="fangwen.dataList"
              :transverseData="fangwen.transverseData"
              :colorList="fangwen.colorList"
              :legendList="fangwen.legendList"
              :colorName="1"
              :innerText="'单位: 次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></discountChart>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="contentBox">
          <div class="div">
            <div class="text">
              <p>结语</p>
              <p>{{ header.nowTime }}年，感谢您的辛勤付出！</p>
              <p>为{{ resourceLibrary.studentNum }}名学生带去了知识的温暖。</p>
              <p>{{ header.nowTime + 1 }}年，让我们携手共进，继续让知识闪耀光芒！</p>
              <p>路虽远，行则将至；事虽难，做则必成！</p>
            </div>
          </div>
          <div class="tearcherImg"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import vcolumnarChartColor from "@/components/chart/vcolumnarChartColor.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
export default {
  name: "CareerBigDataIndividualizationReport",
  components: {
    circularChart,
    vcolumnarChart,
    vcolumnarChartColor,
    tcolumnarChart,
    discountChart,
  },
  data() {
    return {
      completeNum: 0,
      year: "",
      zykStatus: "已立项",
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色

      header: {
        allHostUnit: "",
        coHostUnit: [],
        endTime: "",
        hostUnit: "",
        startTime: "",
        status: "",
        zykName: "",
        zykNum: "",
        nowTime: null,
      },

      colorList: [
        "#ff7f50",
        "#87cefa",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      ziyuan: {
        dataList: [],
      },

      // 有效的
      top: {
        zykRank: 0,
      },
      typeDistribution: {
        // 图2  当前资源库资源、课程情况
        dataList: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0,
      },
      resourceLibrary: {
        // 图1 资源库注册用户类型分布总体情况
        dataList: [],
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
      },

      resourceVisits: {
        tableList: [],
      },
      resourceVisits2: {
        tableList: [],
      },

      usersMonth: {
        // 图3 用户新增情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        teacherNum: 0,
        studentNum: 0,
      },
      allLogModuleCase: {
        dataList: [],
        total: 0,
        Max: {},
      },
      LogModuleCase: {
        dataList: [],
        total: 0,
        Max: {},
      },
      tearcherList: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Max: {},
      },
      studentList: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Max: {},
      },
      // 年报-年份数据对比分析
      zykTotal: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: [],
      },
      fangwen: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: [],
      },
      courseTotal: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: [],
        standardNum: "",
        individuaNum: "",
        total: null,
      },

      userTotal: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: [],
      },
      // 资源访问总数
      accessMonth: {
        total: null,
      },
      // 课程访问情况
      visitsMonth: {
        total: null,
      },
      // 资源访问情况
      resourcesMonth: {
        total: null,
      },
      //  新增课程
      coursesMonth: {
        total: null,
      },

      Handler1: {},
      Handler2: {},
      Handler3: {
        dataList: [],
      },
      Handler4: {
        dataList: [],
        year: "",
        month: "",
        day: "",
      },

      //
      NowCourse: {
        individuaNum: "",
        standardNum: "",
        dataList: [],
      },
      zykName: "",
      zykNum: "",
      year: "",
      month: "",
      day: "",
      zykid: "",
    };
  },
  created() {
    if (this.$route.query) {
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
      this.zykid = this.$route.query.zykid;
      const year = this.$route.query.yearOrMonth;
      const monthly = this.$route.query.yearOrMonth;
      this.$route.query.startTime = `${year}-${monthly}-${1}`;
      this.$route.query.endTime = `${year}-${monthly}-${new Date(year, monthly, 0).getDate()}`;
      this.header = this.$route.query;
      this.year = `${year}-${monthly}`;
    }

    // 有效的
    this.fenxi(); //   年度基本信息
    this.getHandler1();
    this.getHandler2();
    this.tops();
    this.getHandler3();
    this.typeDistributionDom(); //    资源库占比
    this.getHandler4();
    this.resourceLibraryDom(); //    资源库注册用户类型分布总体情况
    this.resourcesMonthDom();
    this.accessMonthDom();
    this.resourceVisitsDom(); //    访问量排名前十的资源
    this.resourceVisits2Dom(); //    访问量排名前十的课程
    this.usersMonthDom(); //    新增教师 + 学生用户数
    this.getAllLogModuleCase();
    this.tearcherTop(); //    总访问量较多的教师（前十）
    this.studentTop(); //    总访问量较多的教师（前十）
    // 年报-年份数据对比分析   （1-资源总数对比分析）
    this.getYearReportByDataAnalysis4();

    this.coursesMonthDom();
    this.visitsMonthDom();
    this.getCourseCount();
  },
  watch: {
    completeNum(val) {
      console.log(val);
    },
  },
  methods: {
    // 处理数据
    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },
    tops() {
      this.$axios
        .post(this.$apiurls.report_yaer_getZykRankYear, {
          loading: false,
        })
        .then((res) => {
          this.top.zykRank = res.data.zykRank;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 当前资源库资源、课程情况
    typeDistributionDom() {
      this.$axios
        .post(this.$apiurls.report_year_getStatResourceDataEntity, 1, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            const arrList = [];
            arrList.push(
              {
                name: "视频类",
                value: res.data.videoNum,
              },
              {
                name: "动画类",
                value: res.data.animationNum,
              },
              {
                name: "图形图像类",
                value: res.data.graphicImageNum,
              },
              {
                name: "虚拟仿真类",
                value: res.data.virtualSimulationNum,
              },
              {
                name: "文本类",
                value: res.data.textNum,
              },
              {
                name: "微课类",
                value: res.data.smallCourseNum,
              },
              {
                name: "音频类",
                value: res.data.shenyangNum,
              },
              {
                name: "ppt和富媒体等",
                value: res.data.pptNum + res.data.coursewareNum + res.data.mediaNum,
              },
              {
                name: "其他",
                value: res.data.otherNum,
              }
            );
            this.typeDistribution.spNumber = res.data.videoNum;
            this.typeDistribution.dhNumber = res.data.animationNum;
            this.typeDistribution.txtxNumber = res.data.graphicImageNum;
            this.typeDistribution.xnfzNumber = res.data.virtualSimulationNum;
            this.typeDistribution.wbNumber = res.data.textNum;
            this.typeDistribution.wkNumber = res.data.smallCourseNum;
            this.typeDistribution.ypNumber = res.data.shenyangNum;
            this.typeDistribution.kjNumber = res.data.coursewareNum;
            this.typeDistribution.pptNumber = res.data.pptNum;
            this.typeDistribution.fmtNumber = res.data.mediaNum;
            this.typeDistribution.qtNumber = res.data.otherNum;
            this.typeDistribution.total = res.data.total;
            this.typeDistribution.dataList = arrList;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    fenxi() {
      this.$axios
        .post(this.$apiurls.report_yaer_getZykInformationVo, {
          loading: false,
        })
        .then((res) => {
          this.header = res.data;
          this.header.nowTime = parseInt(res.data.endTime.slice(0.4));
          this.header.allHostUnit = res.data.allHostUnit.replace(",", "，");
          this.getLogModuleCase(this.header.nowTime);
          this.completeNum = this.completeNum + 1;

          this.getYearReportByDataAnalysis1();
          this.getYearReportByDataAnalysis2();
          this.getYearReportByDataAnalysis3();
        });
    },

    resourceLibraryDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_resourceLibrary, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            const arrList = [];
            arrList.push(
              {
                name: "教师",
                value: res.data.teacherNum,
              },
              {
                name: "学生",
                value: res.data.studentNum,
              },
              {
                name: "企业用户",
                value: res.data.enterpriseNum,
              },
              {
                name: "社会学习者",
                value: res.data.socialNum,
              }
            );
            this.resourceLibrary.teacherNum = res.data.teacherNum;
            this.resourceLibrary.studentNum = res.data.studentNum;
            this.resourceLibrary.enterpriseNum = res.data.enterpriseNum;
            this.resourceLibrary.socialNum = res.data.socialNum;
            this.resourceLibrary.dataList = arrList;
            this.completeNum = this.completeNum + 1;
          }
        });
    },

    // 用户访问较多的资源
    resourceVisitsDom() {
      this.$axios
        .post(
          this.$apiurls.report_year_getStatLittletenEntityListByYearReport,
          {
            limitNum: "11",
            statType: 35,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }

            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].name.length > 25) {
                res.data[i].name = res.data[i].name.slice(0, 22) + "...";
              }
            }
            this.resourceVisits.tableList = res.data;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 用户访问较多课程
    resourceVisits2Dom() {
      this.$axios
        .post(
          this.$apiurls.report_year_getStatLittletenEntityListByYearReport,
          {
            limitNum: "11",
            statType: 36,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }

            this.resourceVisits2.tableList = res.data;

            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].author.length > 35) {
                res.data[i].author = res.data[i].author.slice(0) + "...";
              }
            }
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 教师 + 学生新增用户数
    usersMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 8, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            const arrList = [];
            for (let i = 0; i < res.data.length; i++) {
              arrList.push(res.data[i].value);
            }

            let teacherNum = 0;
            let studentNum = 0;
            let societyNum = 0;
            let enterpriseNum = 0;

            // 新增教师的数量
            let teacherArray = res.data[0].value;
            for (let i = 0; i <= teacherArray.length - 1; i++) {
              teacherNum += parseFloat(teacherArray[i]);
            }

            // 新增学生的数量
            let studentArray = res.data[1].value;
            for (let i = 0; i <= studentArray.length - 1; i++) {
              studentNum += parseFloat(studentArray[i]);
            }

            // 新增社会学习者的数量
            let societyArray = res.data[2].value;
            for (let i = 0; i <= studentArray.length - 1; i++) {
              societyNum += parseFloat(societyArray[i]);
            }

            // 新增企业用户数量
            let enterprisArray = res.data[3].value;
            for (let i = 0; i <= studentArray.length - 1; i++) {
              enterpriseNum += parseFloat(enterprisArray[i]);
            }
            this.usersMonth.dataList = arrList;
            this.usersMonth.transverseData = res.data[0].name;
            this.usersMonth.legendList = ["教师", "学生", "企业用户", "社会学习者"];
            this.usersMonth.colorList = this.colorList;
            this.usersMonth.teacherNum = teacherNum;
            this.usersMonth.studentNum = studentNum;
            this.usersMonth.societyNum = societyNum;
            this.usersMonth.enterpriseNum = enterpriseNum;
            this.completeNum = this.completeNum + 1;
          }
        });
    },

    // 总访问量较多的教师（前十）
    tearcherTop() {
      this.$axios
        .post(
          this.$apiurls.report_year_getStatLittletenEntityList,
          { statType: 33, limitNum: 10 },
          {
            loading: false,
          }
        )
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].author.length > 3) {
              res.data[i].author = res.data[i].author.slice(0, 3);
            }
          }
          res.data.forEach((item) => {
            this.tearcherList.dataList.push(item.num);
            this.tearcherList.transverseData.push(item.author);
          });
          this.tearcherList.colorList = this.colorList;
          this.tearcherList.Max = this.tearcherList.transverseData[0];
          this.completeNum = this.completeNum + 1;
        });
    },
    getLogModuleCase() {
      this.$axios
        .post(
          this.$apiurls.getLogModuleCase,
          { zykid: this.zykid, year: this.header.nowTime },
          { loading: false }
        )
        .then((res) => {
          if (res) {
            let arr = [
              {
                name: "课程模块",
                value: res.data.courseModule,
              },
              {
                name: "资源素材模块",
                value: res.data.resourceModule,
              },
              {
                name: "论坛模块",
                value: res.data.forumModule,
              },
              {
                name: "作业模块",
                value: res.data.taskModule,
              },
              {
                name: "考试模块",
                value: res.data.examinationModule,
              },
              {
                name: "其他模块",
                value: res.data.otherModule,
              },
            ];
            arr.sort((a, b) => a.value > b.value);
            this.LogModuleCase.dataList = arr;
            this.LogModuleCase.Max = arr[0];
            this.LogModuleCase.total = 0;
            arr.forEach((item) => {
              this.LogModuleCase.total += item.value;
            });
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    getAllLogModuleCase() {
      this.$axios
        .post(this.$apiurls.getLogModuleCase, { zykid: this.zykid }, { loading: false })
        .then((res) => {
          if (res) {
            let arr = [
              {
                name: "课程模块",
                value: res.data.courseModule,
              },
              {
                name: "资源素材模块",
                value: res.data.resourceModule,
              },
              {
                name: "论坛模块",
                value: res.data.forumModule,
              },
              {
                name: "作业模块",
                value: res.data.taskModule,
              },
              {
                name: "考试模块",
                value: res.data.examinationModule,
              },
              {
                name: "其他模块",
                value: res.data.otherModule,
              },
            ];
            arr.sort((a, b) => a.value > b.value);
            this.allLogModuleCase.dataList = arr;
            this.allLogModuleCase.Max = arr[0];
            this.allLogModuleCase.total = 0;
            arr.forEach((item) => {
              this.allLogModuleCase.total += item.value;
            });
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 总访问量较多的学生（前十）
    studentTop() {
      this.$axios
        .post(
          this.$apiurls.report_year_getStatLittletenEntityListByYearReport,
          { statType: 34, limitNum: 10 },
          {
            loading: false,
          }
        )
        .then((res) => {
          res.data.forEach((item) => {
            this.studentList.dataList.push(item.num);
            this.studentList.transverseData.push(item.author);
          });
          this.studentList.colorList = this.colorList;
          this.studentList.Max = this.studentList.transverseData[0];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 年报-年份数据对比分析 (资源总数对比分析)
    getYearReportByDataAnalysis1() {
      this.$axios
        .post(
          this.$apiurls.getYearDataAddAnalysis,
          { type: 1, year: this.header.nowTime },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.zykTotal.dataList = res.data.dataList;
          this.zykTotal.colorList = this.colorList;
          this.zykTotal.legendList = res.data.year;
          this.zykTotal.transverseData = res.data.transverseData;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 年报-年份数据对比分析 (课程总数对比分析)
    getYearReportByDataAnalysis2() {
      this.$axios
        .post(
          this.$apiurls.getYearDataAddAnalysis,
          { type: 2, year: this.header.nowTime },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseTotal.dataList = res.data.dataList;
          this.courseTotal.colorList = this.colorList;
          this.courseTotal.legendList = res.data.year;
          this.courseTotal.transverseData = res.data.transverseData;
          // 标准化课程
          this.courseTotal.standardNum = res.data.dataList[0][1] - res.data.dataList[0][0];
          // 个性化课程
          this.courseTotal.individuaNum = res.data.dataList[1][1] - res.data.dataList[1][0];
          this.courseTotal.total = res.data.dataList[0][1] + res.data.dataList[1][1];
          this.completeNum = this.completeNum + 1;
        });
    },
    getCourseCount() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getCourseCount, {
          loading: false,
        })
        .then((res) => {
          let data = res.data;
          this.NowCourse.individuaNum = data.find((item) => item.name === "个性化课程").value;
          this.NowCourse.standardNum = data.find((item) => item.name === "标准化课程").value;
          this.NowCourse.dataList.push(
            { name: "个性化课程", value: this.NowCourse.individuaNum },
            { name: "标准化课程", value: this.NowCourse.standardNum }
          );
          this.completeNum = this.completeNum + 1;
        });
    },
    // 年报-年份数据对比分析 (用户数对比分析)
    getYearReportByDataAnalysis3() {
      this.$axios
        .post(
          this.$apiurls.getYearDataAddAnalysis,
          { type: 3, year: this.header.nowTime },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userTotal.dataList = res.data.dataList;
          this.userTotal.colorList = this.colorList;
          this.userTotal.legendList = res.data.year;
          this.userTotal.transverseData = res.data.transverseData;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 年报-年份数据对比分析 (访问量对比分析)
    getYearReportByDataAnalysis4() {
      this.$axios
        .post(
          this.$apiurls.getYearReportByDataAnalysis,
          { type: 4 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.fangwen.dataList = res.data.dataList;
          this.fangwen.colorList = this.colorList;
          this.fangwen.legendList = res.data.transverseData;
          this.fangwen.transverseData = res.data.legendList;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 新增资源
    resourcesMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 9, {
          loading: false,
        })
        .then((res) => {
          let total = 0;
          let arrList = [];
          let transverseData = [];
          let newArray = res.data[0];
          for (let i = 0; i <= newArray.name.length - 1; i++) {
            transverseData.push(newArray.name[i]);
          }
          for (let i = 0; i <= newArray.value.length - 1; i++) {
            total += parseFloat(newArray.value[i]);
            arrList.push(newArray.value[i]);
          }
          this.resourcesMonth.total = total;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 新增课程
    coursesMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 3, {
          loading: false,
        })
        .then((res) => {
          let total = 0;
          let newArray = res.data[0];

          for (let i = 0; i <= newArray.value.length - 1; i++) {
            total += parseFloat(newArray.value[i]);
          }
          this.coursesMonth.total = total;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源访问情况
    accessMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 4, {
          loading: false,
        })
        .then((res) => {
          let totalArray = res.data[0].value;
          let total = 0;
          for (let i = 0; i <= totalArray.length - 1; i++) {
            total += parseFloat(totalArray[i]);
          }
          this.accessMonth.total = total;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 课程访问情况
    visitsMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 5, {
          loading: false,
        })
        .then((res) => {
          let valueArray = res.data[0].value;
          let total = 0;
          for (let i = 0; i <= valueArray.length - 1; i++) {
            total += parseFloat(valueArray[i]);
          }
          this.visitsMonth.total = total;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源库全国数据
    getHandler1() {
      this.$axios
        .post(
          this.$apiurls.getYearReportByDataAnalysisContent,
          { type: 1 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.Handler1 = res.data.dataList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源库基本数据分析
    getHandler2() {
      this.$axios
        .post(
          this.$apiurls.getYearReportByDataAnalysisContent,
          { type: 2 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.Handler2.dataList = res.data.dataList;
          let year = res.data.dataList[0].replace("年", "-");
          let month = year.replace("月", "-");
          let day = month.replace("日", "");
          let frist = day.indexOf("-");
          let second = day.lastIndexOf("-");
          this.year = day.slice(0, frist);
          this.month = day.slice(frist + 1, frist + 3);
          this.day = day.slice(second + 1, day.length);
          this.completeNum = this.completeNum + 1;
        });
    },
    // 资源库基本数据分析
    getHandler3() {
      this.$axios
        .post(
          this.$apiurls.getYearReportByDataAnalysisContent,
          { type: 3 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.Handler3.dataList = res.data.dataList;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 课程占比
    getHandler4() {
      this.$axios
        .post(
          this.$apiurls.getYearReportByDataAnalysisContent,
          { type: 4 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.Handler4.dataList = res.data.dataList;

          let year = res.data.dataList[0].replace("年", "-");
          let month = year.replace("月", "-");
          let day = month.replace("日", "");
          let frist = day.indexOf("-");
          let second = day.lastIndexOf("-");

          this.Handler4.year = day.slice(0, frist);
          this.Handler4.month = day.slice(frist + 1, frist + 3);
          this.Handler4.day = day.slice(second + 1, day.length);
          this.completeNum = this.completeNum + 1;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0px;
  margin: 0px;
}
.bigBox {
  height: 13700px;
  // 头部分
  .hearder {
    .image {
      width: 100%;
      height: 700px;
      background: url("../../../../public/4.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      display: flex;

      .title {
        box-sizing: border-box;
        padding: 0 3%;
        text-align: center;
        p {
          color: rgba(0, 210, 255, 1);
          font-size: 70px;
          font-weight: 700;
        }
        span {
          display: block;
          font-weight: 700;
          color: rgba(255, 255, 255, 1);
          font-size: 45px;
        }

        &:nth-child(1) span {
          margin-top: 20px;
        }
      }
    }
  }

  .fristTitle,
  .secondTitle {
    display: flex;
    justify-content: space-around;
    margin: 85px 0px;
    .line {
      width: 520px;
      border-bottom: 5px solid #8799b9;
    }
    .lines {
      width: 350px;
      border-bottom: 5px solid #8799b9;
    }
    h1 {
      font-size: 45px;
      color: #043fa3;
      margin: 0px 20px;
    }
  }
  .chartBox {
    height: 620px;
    display: flex;
    align-items: center;
    p {
      margin-bottom: 36px;
    }

    .left_box {
      box-sizing: border-box;
      color: #000;
      font-size: 34px;
      p {
        margin-bottom: 36px;
      }
    }

    .right_box {
      width: 100%;
      p {
        text-align: center;
        font-size: 34px;
      }
    }
  }

  .chartBoxTitle {
    display: flex;
    align-items: center;
    p {
      margin-bottom: 36px;
    }

    .left_box {
      box-sizing: border-box;
      color: #000;
      font-size: 34px;
      p {
        margin-bottom: 36px;
      }
    }

    .right_box {
      width: 100%;
      p {
        text-align: center;
        font-size: 34px;
      }
    }
  }
  .Title {
    width: 1630px;
    margin: 0 auto;
  }
  .content {
    color: #000;
    p {
      font-size: 34px;
      margin-bottom: 36px;
    }
  }
  .main::before {
    content: "";
    width: 100%;
    height: 100%;
    background: url("../../../../public/3.png");
    background-size: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.45;
  }

  .chart_box {
    width: 100%;
    height: auto;
    margin-left: 0px;
    clear: both;

    .left_chart_box,
    .right_chart_box {
      text-align: center;
      p {
        font-size: 36px;
      }
    }
  }

  .echartsHeight {
    width: 80%;
    // height: calc(400vw / 1080 * 300);
    height: 600px;
    // height: 28rem;
    margin: 10px auto 0px;
  }

  .echartsHeights {
    // height: calc(400vw / 1080 * 300);
    height: 600px;
    // height: 28rem;
    margin: 10px 50px 0px;
  }

  .footer {
    width: 100%;
    height: 500px;
    background: url("../../../../public/2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 240px;
    position: relative;
    box-sizing: border-box;
    padding-top: 2.1%;
    padding-left: 5%;

    .text {
      color: #fff;
      font-size: 35px;
      p {
        margin-bottom: 30px;
        font-weight: 700;
        &:nth-child(1) {
          margin-bottom: 40px;
        }
      }
    }
    .tearcherImg {
      width: 32%;
      height: 600px;
      position: absolute;
      right: 10%;
      bottom: 0px;
      background: url("../../../../public/1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}

.biaoge {
  width: 100%;
  max-height: 700px;
  margin: 40px auto 0px;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 50px;
  color: #707f9d;
  font-size: 30px;
  line-height: 50px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  // background: #fff;
  color: #566178;
}

.course tr:nth-child(2n-1) {
  // background: #7ed2ff;
  background: rgb(73, 187, 233);
  color: #566178;
  // color: #fff;
  // color: #566178;
}

.course tr:first-child {
  // background: #66adff;
  background: rgb(88, 136, 248);
  color: #fff;
}

.yellow {
  text-shadow: 1px 0px 1px #f99a37;
  color: #ef9739 !important;
}

.height {
  height: 576px;
}
</style>
<style lang="scss" scoped>
.page-box {
  padding: 7% 0;
  height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // border: 1px solid red;
  .m-top150 {
    margin-top: 150px;
  }
  .m-top100 {
    margin-top: 100px;
  }
  .biaoge {
    width: 95%;
    margin: 25px auto;
    .course {
      text-align: center;
      margin: 0px 10px;
      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;
        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }
        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
}
.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}
</style>
